(function () {
  'use strict';

  /* @ngdoc object
   * @name itecAdministracio.shared.document
   * @description
   *
   */
  angular
    .module('itecAdministracio.shared.document', [
      'itecGuicomponents.commonControls',
      'ngFileUpload'
    ]);
}());
